<template>
  <div>
    <SearchBar
      :search-result="searchResult"
      @pagination="pagination"
      @search="search"
      @inputKeyword="inputKeyword"
      class="mt-2"
      placeholder="名前・所属・メールアドレス"
    >
      <v-btn @click="openModalInvite()" color="primary" class="mt-2"
        >アカウント招待</v-btn
      >
      <div class="belong-to-select-container">
        所属先
        <v-select
          :items="getFilterItems()"
          v-model="selectedBelongTypeFilter"
          item-text="text"
          class="belong-to-select"
          return-object
        />
      </div>
    </SearchBar>
    <v-data-table
      :headers="headers"
      :items="searchResult.items"
      :loading="loading.searchResult"
      hide-actions
      class="elevation-1 mt-2"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left no-wrap">
            <v-btn
              v-if="props.item.canEdit"
              @click="openModalEdit(props.item)"
              small
              color="primary"
              class="mr-2 ml-0"
              >編集</v-btn
            >
            <v-btn
              v-if="
                props.item.canChangePermission &&
                  props.item.belongType !== 'system owner'
              "
              @click="openModalChangePermission(props.item)"
              small
              color="primary"
              class="ma-0"
              >権限編集</v-btn
            >
          </td>
          <td class="text-xs-left no-wrap">{{ props.item.name }}</td>
          <td class="text-xs-left no-wrap">
            <BelongType :value="props.item.belongType" />
            {{ props.item.belongName }}
          </td>
          <td class="text-xs-left no-wrap">{{ props.item.email }}</td>
          <td class="text-xs-left no-wrap">{{ props.item.userTypeName }}</td>
          <td class="text-xs-left">
            <AppStatus :value="props.item.status" :showText="false" with-icon />
          </td>
        </tr>
      </template>
    </v-data-table>
    <ModalInvite
      v-model="isModalInviteActive"
      :loading="loading"
      :belong-type="userBelongType"
      :system-owner-list="systemOwnerList"
      :agency-list="agencyList"
      :advertiser-list="advertiserList"
    />
    <ModalEdit
      v-model="isModalEditActive"
      :item="currentItem"
      @save="retrySearch"
    />
    <!-- 代理店権限編集モーダル -->
    <EditAgencyAccountAuthModal
      ref="editAgencyAccountAuthModal"
      :dispatch-get-agency-account-auth="dispatchGetAgencyAccountAuth"
      :agency-list="adminAgencyList"
      :agency-auth-chain="agencyAuthChain"
      @save="retrySearch"
    />
    <!-- 広告主権限編集モーダル -->
    <EditAdvertiserAccountAuth
      ref="editAdvertiserAccountAuthModal"
      :dispatch-get-advertiser-account-auth="dispatchGetAdvertiserAccountAuth"
      :advertiser-list="adminAdvertiserList"
      :advertiser-auth-chain="advertiserAuthChain"
      @save="retrySearch"
    />
  </div>
</template>

<script>
import ModalInvite from '@/components/Admin/Account/ModalInvite'
import ModalEdit from '@/components/Admin/Account/ModalEdit'
import EditAgencyAccountAuthModal from '@/components/Admin/Account/EditAgencyAccountAuthModal'
import EditAdvertiserAccountAuth from '@/components/Admin/Account/EditAdvertiserAccountAuthModal'
import SearchBar from '@/components/Shared/Search/SearchBar'
import BelongType from '@/components/Shared/Presentation/BelongType'
export default {
  name: 'AccountList',
  components: {
    SearchBar,
    BelongType,
    ModalInvite,
    ModalEdit,
    EditAdvertiserAccountAuth,
    EditAgencyAccountAuthModal,
  },
  props: {
    loading: {
      type: Object,
      default: () => {},
    },
    searchResult: {
      type: Object,
      default: () => {},
    },
    userBelongType: {
      type: String,
      default: '',
    },
    userBelongId: {
      type: [Number, String],
      default: 0,
    },
    userType: {
      type: String,
      default: '',
    },
    systemOwnerList: {
      type: Array,
      default: () => [],
    },
    agencyList: {
      type: Array,
      default: () => [],
    },
    advertiserList: {
      type: Array,
      default: () => [],
    },
    adminAgencyList: {
      type: Array,
      default: () => [],
    },
    agencyListForSearch: {
      type: Array,
      default: () => [],
    },
    agencyAuthChain: {
      type: Object,
      default: () => {},
    },
    adminAdvertiserList: {
      type: Array,
      default: () => [],
    },
    advertiserListForSearch: {
      type: Array,
      default: () => [],
    },
    advertiserAuthChain: {
      type: Object,
      default: () => {},
    },
    dispatchGetAgencyAccountAuth: {
      type: Function,
      default: () => [],
    },
    dispatchGetAdvertiserAccountAuth: {
      type: Function,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: '編集/削除', value: 'operation', sortable: false },
        { text: '名前', value: 'name' },
        { text: '所属', value: 'belongName' },
        { text: 'メールアドレス', value: 'email' },
        { text: 'ユーザ種別', value: 'userType' },
        { text: 'ステータス', value: 'status' },
      ],
      currentItem: {},
      isModalInviteActive: false,
      isModalEditActive: false,
      searchKeyword: undefined,
      searchBy: 'advertiser',
      selectedBelongTypeFilter: { text: 'すべて表示', value: 'all' },
      agencyForSearch: undefined,
      advertiserForSearch: undefined,
    }
  },
  watch: {
    userBelongId() {
      this.initSearch()
    },
    selectedBelongTypeFilter() {
      this.search()
    },
  },
  mounted() {
    this.initSearch()
  },
  methods: {
    initSearch() {
      if (!this.userBelongId || this.userBelongType === 'system owner') return
      this.searchBy = this.userBelongType
      if (this.userBelongType === 'agency') {
        this.agencyForSearch = this.userBelongId
      } else {
        this.advertiserForSearch = this.userBelongId
      }
    },
    inputKeyword(keyword) {
      this.searchKeyword = keyword
    },
    pagination(e) {
      this.$emit('search', { keyword: this.searchKeyword, pageNo: e })
    },
    search() {
      // すべての所属のアカウントを取得する場合、undefinedとする
      const belongType = (() => {
        if (this.selectedBelongTypeFilter.value === 'all') return undefined
        return this.selectedBelongTypeFilter.value
      })()
      const params = { keyword: this.searchKeyword, belongType: belongType }
      this.$emit('search', params)
    },
    retrySearch() {
      let params = {
        keyword: this.searchKeyword,
        pageNo: this.searchResult.pageNo,
      }
      this.$emit('search', params)
    },
    openModalInvite() {
      this.isModalInviteActive = true
    },
    openModalEdit(item) {
      if (!this.canEditPermission(item)) {
        this.openModalEditError()
        return
      }
      this.currentItem = item
      this.isModalEditActive = true
    },
    openModalChangePermission(item) {
      if (!this.canEditPermission(item)) {
        this.openModalEditError()
        return
      }
      const belongType = item.belongType
      switch (belongType) {
        case 'advertiser':
          // accountタイプによって開くmodalを分岐させる
          this.$refs.editAdvertiserAccountAuthModal.prepare(item)
          break
        case 'agency':
          // accountタイプによって開くmodalを分岐させる
          this.$refs.editAgencyAccountAuthModal.prepare(item)
          break
      }
    },
    async openModalEditError() {
      const statusError = await this.$confirm('アカウント編集エラー', {
        okText: '閉じる',
        onlyOk: true,
        body: `ユーザー種別が管理者に設定されているユーザーの編集については、契約をしている代理店もしくは、システムの管理者へ編集をご依頼下さい。`,
      })
      if (statusError) return
    },
    canEditPermission(item) {
      if (this.userBelongType === 'system owner') return true
      else if (this.userBelongType === 'agency') {
        return (
          (this.userType === 'administrator' &&
            ((item.belongType === 'agency' &&
              item.userType !== 'administrator') ||
              item.belongType === 'advertiser')) ||
          (this.userType !== 'administrator' &&
            item.belongType === 'advertiser' &&
            item.userType !== 'advertiser')
        )
      } else if (this.userBelongType === 'advertiser') {
        return (
          this.userType === 'administrator' &&
          item.belongType === 'advertiser' &&
          item.userType !== 'administrator'
        )
      }
      return false
    },
    getFilterItems() {
      switch (this.userBelongType) {
        case 'system owner':
          return [
            { text: 'すべて表示', value: 'all' },
            { text: 'システムオーナーのみ表示', value: 'systemOwner' },
            { text: '代理店のみ表示', value: 'agency' },
            { text: '広告主のみ表示', value: 'advertiser' },
          ]
        case 'agency':
          return [
            { text: 'すべて表示', value: 'all' },
            { text: '代理店のみ表示', value: 'agency' },
            { text: '広告主のみ表示', value: 'advertiser' },
          ]
        case 'advertiser':
          return [{ text: 'すべて表示', value: 'all' }]
        default:
          return []
      }
    },
  },
}
</script>

<style scoped>
.no-wrap {
  white-space: nowrap;
}
.title {
  font-weight: normal;
  color: #614545;
}
.selection {
  max-width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.belong-to-select {
  max-width: 200px;
  margin-left: 10px;
}
.belong-to-select-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 20px;
}
</style>
